<template>
    <div>
        <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#173EA3"
      :is-full-page="fullPage"
    ></loading>
    <div class="" style="height:600px;overflow:scroll">

		<div  class="col-12 lg:col-6 xl:col-12"  v-for="(data,key) in userlist" :key="key" >

                <br>
			<div class="card mb-0" style="color:white;background-color:#173EA3;font-size:12px;line-height:0.9" >

				<div class="grid">
					
					<div class="grid col-4 md:col-10">
						<div class="col-6 md:col-6">
							<span>status : </span><span style="text-align:right"><b>{{data.status}}</b></span>
						</div>
							<div class="col-6 md:col-6">
							<span>Customer Status : </span><b>{{data.customer_status}}</b>
						</div>
						<div class="col-6 md:col-6">
							<span>rating : </span><b>{{data.rating}}</b>
						</div>
                        <div class="col-6 md:col-6">
							<span>date : </span><b>{{data.date}}</b>
						</div>
                        <div class="col-6 md:col-6">
							<span>Service Name : </span><b>{{data.service_provider_details.service_name}}</b>
						</div>

					</div>
						
				</div>
	
			</div>

		
		</div>
		
		<div class="col-12" v-if="list==''" style="text-align:left">
            <br>	
			Data Not Found
		</div>
    </div>
   
    
          
</div>
</template>

<script>
import apis from "@/apis";
import ProductService from "../../service/ProductService";
import { FilterMatchMode } from "primevue/api";
import readXlsxFile from 'read-excel-file'


export default {
  data() {
    return {
      group_user_id:'',
      stops_item:[],
      stops_options:[],
      edit_productDialog:false,
      file:[],
      limit: 10,
      filters: {},
      offset: 1,
      page_no: 1,
      list:[],

      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,

      productDialog: false,
      table_data: [],
      place_details: "",
      pick_dropdown: [],
      pick_search: "",
      pick_search_array:[],
      pick_dropdown_array:[],


      stops_item_array:[],
      stops_options_array:[],

      name: "",
      status: "",
      location: "",
      mobile_number: "",
      parent_mobile_number:"",

      products: [],
      userlist:[],

      dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" }
      ],
      selectstatus: { name: "Active", value: "Active" },

      productService: null
    };
  },
  props: ["service_id","data_id","user_id"],
  methods: {
   
   
   
    isNumberKey(evt) {
            evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }

  },
 
    get_user_req_details()
    {
          this.isLoadingModel=true;

     
      var data={
  
        service_id:this.service_id,
        _id:this.data_id,
        service_provider_id:this.user_id
    
    };
      var promise = apis.UserServicereqList(data);
      promise
        .then(response => {
          
          this.isLoadingModel=false;
            this.list=[];
            this.list=response.data.data;
            console.log("🚀 ~ file: User_Service_Request.vue:136 ~ this.list:", this.list)
            
          }
        )
    },
    

    D_M_Y_formatDate(date_parm) {
      if (date_parm) {
        let date = new Date(date_parm);
        let dd = date.getDate();
        let mm = date.getMonth() + 1;
        let yyyy = date.getFullYear();
        let new_date = dd + "-" + mm + "-" + yyyy;
        // alert(dd)
        if (dd.toString() != "NaN") {
          //this.receipt_new_date = new_date;
          return new_date;
        } else {
          return date_parm;
        }
      }
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
      };
    }
  },
  watch:
  {
    list:
    {
           
      handler(newValue, oldValue) {
              this.userlist=this.list;
        
      }

    }
  },
  mounted() {
   
    this.get_user_req_details();
  },
  async created() {
    this.productService = new ProductService();
    this.initFilters();
   
  }
};
</script>